import UsageService from "../components/usage/services/usage";
import ApiKeysService from "./api-keys";
import AuditLogsService from "./audit-logs";
import AuthService from "./auth";
import ChangelogsService from "./changelogs";
import ContractsService from "./contracts";
import CustomersService from "./customers";
import DashboardService from "./dashboard";
import InvoicesService from "./invoices";
import LicensesService from "./licenses";
import MarketplaceService from "./marketplace";
import MfaService from "./mfa";
import OrganizationService from "./organization";
import PasswordResetCognitoService from "./passwordResetCognito";
import PasswordResetService from "./passwordReset";
import ProductsService from "./products";
export const services = {
    apiKeysService: new ApiKeysService(),
    auditLogsService: new AuditLogsService(),
    authService: new AuthService(),
    changelogsService: new ChangelogsService(),
    contractsService: new ContractsService(),
    customersService: new CustomersService(),
    dashboardService: new DashboardService(),
    invoicesService: new InvoicesService(),
    licensesService: new LicensesService(),
    marketplaceService: new MarketplaceService(),
    mfaService: new MfaService(),
    organizationService: new OrganizationService(),
    passwordResetService: new PasswordResetService(),
    productsService: new ProductsService(),
    usageService: new UsageService()
};
const cognitoServiceCache = new Map();
export function getPasswordResetCognitoService(config) {
    const cacheKey = `${config.region}::${config.userPoolClientId}`;
    const existingService = cognitoServiceCache.get(cacheKey);
    if (existingService) {
        return existingService;
    }
    const newService = new PasswordResetCognitoService(config);
    cognitoServiceCache.set(cacheKey, newService);
    return newService;
}
